/**
 * Company: SPHMedia
 * Description: A button component for triggering the "Read More" action in an infinite scroll context.
 */

import { ButtonHTMLAttributes, ReactElement } from "react";

type InfiniteScrollReadMoreCTAProps = ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * InfiniteScrollReadMoreCTA
 * Description: A button component for triggering the "Read More" action in an infinite scroll context.
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function InfiniteScrollReadMoreCTA(
  props: InfiniteScrollReadMoreCTAProps,
): ReactElement {
  return (
    <>
      <button
        {...props}
        type="button"
        data-testid="infinite-scroll-read-more-cta"
        className="text-red-500 text-xs font-bold text-center rounded-[4px] bg-red-100 py-3 px-4 w-[169px] h-[41px]"
      >
        தொடர்ந்து படிக்கவும்
      </button>
    </>
  );
}
